import { NgModule } from '@angular/core';
import { TooltipComponent } from './tooltip.component';
import { COMMON_MODULES } from '../../constants/common-modules';

@NgModule({
  declarations: [TooltipComponent],
  imports: [...COMMON_MODULES],
  exports: [TooltipComponent],
})
export class TooltipModule {}
